import ClubFeeCategory from '../dto/ClubFeeCategory';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubFeeCategoryRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/fee-categories`)
                .then((response) => resolve(response.data.data.map((data) => ClubFeeCategory.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
